var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ComplexExcel',{attrs:{"label":_vm.label},on:{"save":_vm.onClickSave,"customAlert":_vm.customAlert}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }